import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { PresenceTypeEnum } from '@/types/presences';

export type TKeepingSessionLayout = {
  presence_type: PresenceTypeEnum;
  presence_id: string;
  x: number;
  y: number;
  w: number;
  h: number;
  min_w: number;
  max_w: number;
  min_h: number;
};

export type TSessionLogo = {
  id: string;
  supports: string[];
};

export type TKeepingSession = {
  name: string;
  workspaces: string[];
  logos: TSessionLogo[];
  people: string[];
  layout: TKeepingSessionLayout[];
};

export type TKeepingSessionResponse = TKeepingSession & { id: string };

export async function postKeepingSession(body: TKeepingSession): Promise<TKeepingSessionResponse> {
  return mediaManagerClient.post('/api/v1/time_keeping_sessions', body);
}

type MutationFn = typeof postKeepingSession;

type TUsePostKeepingSessionParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePostKeepingSession({ config = {} }: TUsePostKeepingSessionParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: postKeepingSession,
    onError(error) {
      addErrorNotification(t('No se ha podido guardar la sesión'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('La sesión se ha guardado correctamente'));
      queryClient.invalidateQueries({
        queryKey: ['time-keeping-sessions'],
        exact: false,
      });
    },
  });
}
